<div class="dialog-header" mat-dialog-title>
  <mat-icon fontSet="material-symbols-outlined">upload_file</mat-icon>
  <span>Upload Paper PDF</span>
</div>


<div mat-dialog-content>
  <app-info-card
    [marginTop]="true"
    [hasContent]="true"
    title="Why can't the PDF be downloaded automatically?"
    type="PRIMARY">
    <span>Most academic publishers restrict direct access via paywalls or DRM.
      Academate only links open-access PDFs. Download the paper manually through your
      institution's library and upload it here.</span>
  </app-info-card>

  <form [formGroup]="uploadForm">
    <div
      class="drop-zone"
      [class.drop-zone--active]="uploadedFile"
      (drop)="onDrop($event)"
      (dragover)="onDragOver($event)"
      (click)="triggerFileInput()"
    >
      <input #fileInput type="file" (change)="onFileSelected($event)" hidden>
      @if (uploadedFile) {
        <mat-icon fontSet="material-symbols-outlined" class="drop-icon drop-icon--ready">check_circle</mat-icon>
        <p class="drop-label">{{ uploadedFile.name }}</p>
        <p class="drop-sub">Click to replace</p>
      } @else {
        <mat-icon fontSet="material-symbols-outlined" class="drop-icon">cloud_upload</mat-icon>
        <p class="drop-label">Drag &amp; drop your PDF here</p>
        <p class="drop-sub">or click to browse files</p>
      }
    </div>
  </form>
</div>

<div mat-dialog-actions class="actions">
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onUpload()" [disabled]="!uploadedFile">
    <mat-icon fontSet="material-symbols-outlined">upload</mat-icon>
    Upload PDF
  </button>
</div>
